import { render, staticRenderFns } from "./LaudoTecnicoDetalhe.vue?vue&type=template&id=cd641004&scoped=true"
import script from "./LaudoTecnicoDetalhe.vue?vue&type=script&lang=js"
export * from "./LaudoTecnicoDetalhe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd641004",
  null
  
)

export default component.exports